import { ConsultationListItem } from './ConsultationListItem';
export default ConsultationListItem;
